export default __webpack_public_path__ + "static/SRUS DSL4 - Especification Del Producto y Datos Técnicos-158b64520c7bdc5f9d76930081510469.pdf";